<div class="popup-wrapper">
    <div class="headings">
        <div class="headings-header">
            <span>Your Swift Allocation</span>
        </div>
        <div class="headings-info">
            <span>Below are your selected Swift investment preferences, you can always choose to modify your preferences from the Dashboard after your account is successfully verified.
            </span>
        </div>
    </div>
    <div class="swift-body">
        <div class="swift-product-wrapper">
            <div *ngFor="let item of productsDataForSwift; let i=index;" class="swift-product-item">
                <span class="property-label">{{item.name}}</span>
                <input class="product-item" type="text" value="{{item.percentage}} %" readonly/>
                <div class="input-info">
                    <div class="input-interest">
                        <span>MHP 
                            <app-tooltip placement="bottom">
                                <i class="infoIcon material-icons info-icon" trigger>info_outline</i>
                                <div content class="tooltip-content">Minimum Holding Period (<strong>MHP</strong>) is the period of months during which the <strong>finzyFLEX</strong> investments cannot be withdrawn to bank account.</div>
                            </app-tooltip> &nbsp;&nbsp;
                            <strong class="interest-value">
                                {{item.mph}}m
                            </strong>
                        </span>
                    </div>
                    <div class="input-interest">
                        <span>Interest: &nbsp; <strong class="interest-value">upto {{item.interest}}% p.a</strong></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="swift-body-btn">
        <button (click)="onClickBack()" class="back-btn">
            Back
        </button>
    </div>
</div>